import { Container, Row, Col } from 'reactstrap'
import { Title } from './Title'
import { GeneralInfo } from './GeneralInfo'
import { CompanyActions } from './CompanyActions'

const CompanyDetails = ({ company, parentCompany }) => {
  const {
    name,
    legalName,
    address,
    address2,
    street2,
    city,
    state,
    country,
    zipcode,
    phone,
    additionalPhone,
    fax,
    website,
    emailDomain,
    types,
    size,
    preQualified,
    preQualifiedExpDate,
    facebook,
    linkedin,
    twitter,
    instagram,
    youtube,
    noBid,
    noBidReason,
    noBidReasonDescription,
    email,
    description,
    segment,
    breadCrumb
  } = company
  return (
    <Container>
      <Row>
        <Col lg="6">
          <Title
            name={name}
            legalName={legalName}
            facebook={facebook}
            twitter={twitter}
            linkedin={linkedin}
            instagram={instagram}
            youtube={youtube}
            breadCrumb={breadCrumb}
          />
        </Col>
        <Col lg="6">
          <CompanyActions company={{ ...company, parentCompany }} />
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          <GeneralInfo
            description={description}
            address={address}
            address2={address2}
            street2={street2}
            city={city}
            country={country}
            state={state}
            zipcode={zipcode}
            phone={phone}
            additionalPhone={additionalPhone}
            fax={fax}
            website={website}
            email={email}
            emailDomain={emailDomain}
            types={types}
            size={size}
            preQualified={preQualified}
            preQualifiedExpDate={preQualifiedExpDate}
            noBid={noBid}
            noBidReason={noBidReason}
            noBidReasonDescription={noBidReasonDescription}
            segment={segment}
            parentCompany={parentCompany}
          />
        </Col>
      </Row>
    </Container>
  )
}

export default CompanyDetails
